export const CUSTOMER_GCS_BASE =
  "https://storage.googleapis.com/playswithguru-27598-customer-sports-prod";

export const GOVERNED_CUSTOMER_OFFERINGS = Object.freeze({
  MLB: Object.freeze({ loader: "mlb-static", prefix: "mlb" }),
  NBA: Object.freeze({ loader: "customer-static", prefix: "nba" }),
  WNBA: Object.freeze({ loader: "customer-static", prefix: "wnba" }),
  NFL: Object.freeze({ loader: "customer-static", prefix: "nfl" }),
  CFB: Object.freeze({ loader: "customer-static", prefix: "cfb" }),
  SOCCER: Object.freeze({ loader: "customer-static", prefix: "soccer" }),
  KBO: Object.freeze({ loader: "customer-static", prefix: "kbo" }),
  NHL: Object.freeze({ loader: "customer-static", prefix: "nhl" }),
});

export const normalizeOffering = (sport) => String(sport || "").trim().toUpperCase();

export const productionOffering = (sport) =>
  GOVERNED_CUSTOMER_OFFERINGS[normalizeOffering(sport)] || null;

export const governedSavedSportKeys = (savedProjectionIds = []) => {
  const referenced = [...new Set(
    savedProjectionIds
      .map((id) => String(id || "").split("|", 1)[0].trim().toUpperCase())
      .filter(Boolean)
  )];
  return {
    governed: referenced.filter((sport) => productionOffering(sport)),
    rejected: referenced.filter((sport) => !productionOffering(sport)),
  };
};

export const isProductionDashboardHost = (location = globalThis.window?.location) =>
  /(?:^|\.)playswithguru\.com$/i.test(String(location?.hostname || "")) ||
  /\.netlify\.app$/i.test(String(location?.hostname || ""));

export const isLocalDashboardHost = (location = globalThis.window?.location) => {
  const hostname = String(location?.hostname || "").toLowerCase();
  return /^(localhost|127\.0\.0\.1)$/.test(hostname) && String(location?.port || "") === "3000";
};

export const governedPointerUrl = (sport) => {
  const offering = productionOffering(sport);
  if (!offering) throw new Error(`Unsupported production offering: ${normalizeOffering(sport) || "UNKNOWN"}`);
  return `${CUSTOMER_GCS_BASE}/${offering.prefix}/current.json`;
};
